import { render, staticRenderFns } from "./indexProjects.vue?vue&type=template&id=0509efb4&scoped=true"
import script from "./indexProjects.vue?vue&type=script&lang=js"
export * from "./indexProjects.vue?vue&type=script&lang=js"
import style0 from "./indexProjects.vue?vue&type=style&index=0&id=0509efb4&prod&scoped=true&lang=css"
import style1 from "./indexProjects.vue?vue&type=style&index=1&id=0509efb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0509efb4",
  null
  
)

export default component.exports